import { Message } from '@arco-design/web-vue'

/**
 * 计算附加费列表中操作列的跨行合并 rowSpan 数组
 * 针对连续的、系统生成的且含有相同 surchargeRuleId 的费用项进行合并
 *
 * @param surcharges 附加费列表数据
 * @returns 对应每一行的 rowSpan 数量数组（0 表示被合并隐藏）
 */
export function computeSurchargeRowSpans(surcharges: any[]): number[] {
  if (!surcharges || surcharges.length === 0) return []

  const rowSpans = new Array(surcharges.length).fill(1)
  let i = 0

  while (i < surcharges.length) {
    const current = surcharges[i]
    // 只有当是系统费用且存在附加费规则 ID 时才参与合并
    if (current && current.isSystem && current.surchargeRuleId) {
      let j = i + 1
      while (
        j < surcharges.length &&
        surcharges[j] &&
        surcharges[j].isSystem &&
        surcharges[j].surchargeRuleId === current.surchargeRuleId
      ) {
        rowSpans[i]++
        rowSpans[j] = 0 // 标记该行此单元格被合并并隐藏
        j++
      }
      i = j // 跳过已合并的行
    } else {
      i++
    }
  }

  return rowSpans
}

/**
 * 统一处理附加费规则详情页的内部路由跳转
 * 不再使用 window.open 打开浏览器新标签页，改为使用当前 SPA 内部跳转
 *
 * @param record 表格行数据
 * @param router Vue Router 实例
 * @param type 运价类型：'air' | 'lcl'
 * @param t 国际化翻译函数
 */
export function handleJumpToSurcharge(
  record: any,
  router: any,
  type: 'air' | 'lcl',
  t?: (key: string, fallback?: string) => string
): void {
  const ruleId = record.surchargeRuleId
  if (!ruleId) {
    const warnMsg = t ? t('saas.rateManagement.lcl.messages.noSurchargeRuleId', '未找到关联的附加费规则ID') : '未找到关联的附加费规则ID'
    Message.warning(warnMsg)
    return
  }

  let path = ''
  if (type === 'air') {
    path = `/saas/surcharge-management/air/detail/edit/${ruleId}`
  } else if (type === 'lcl') {
    if (record.feeType === 1 || record.type === 'OCEAN_EXTRA') {
      path = `/saas/surcharge-management/lcl/ocean-freight/detail/edit/${ruleId}`
    } else if (record.feeType === 2 || record.type === 'POR') {
      path = `/saas/surcharge-management/lcl/pol/detail/edit/${ruleId}`
    } else if (record.feeType === 3 || record.type === 'FND') {
      path = `/saas/surcharge-management/lcl/pod/detail/edit/${ruleId}`
    }
  }

  if (path) {
    const currentPath = router.currentRoute.value.fullPath
    // Append returnTo query parameter
    const sep = path.includes('?') ? '&' : '?'
    router.push(`${path}${sep}returnTo=${encodeURIComponent(currentPath)}`)
  } else {
    const errorMsg = t ? t('saas.rateManagement.lcl.messages.unknownSurchargeType', '未知的附加费类型，无法跳转') : '未知的附加费类型，无法跳转'
    Message.warning(errorMsg)
  }
}
